/**
 * Utility function, creates AoPS.Contest if it doesn't exist already.
 */

AoPS.Utils.initKeyChain(AoPS, "Contests", "Models");

// Note: Extends from contests_common_models.js, which has the declaration for
//   many of the raw types.
AoPS.Contests.Models = (function (Models) {
	Models.Master = Models.GenericMaster.extend({
		initialize: function () {
			this.addOrUpdateContestPortalRequestedUser(
				AoPS.bootstrap_data.contest_portal_requested_users || []
			);
			this.addOrUpdateSpecialRegisterHost(
				AoPS.bootstrap_data.contest_portal_hosts || []
			);
			this.addOrUpdateContestFlavor(AoPS.bootstrap_data.contest_flavors || []);
			this.addOrUpdateContest(AoPS.bootstrap_data.contests || []);
			this.addOrUpdateContestCms(AoPS.bootstrap_data.contest_cms || []);
			this.set("user_type", AoPS.bootstrap_data.user_type);
			this.set(
				"supervisor_registration_has_ended",
				AoPS.bootstrap_data.supervisor_registration_has_ended
			);

			_.each(
				["contest_terms"],
				_.bind(function (key) {
					this.set(key, AoPS.bootstrap_data[key]);
				}, this)
			);
		},

		addOrUpdateSpecialRegisterHost: function (objects, options) {
			this.addOrUpdate(
				"contest_portal_hosts",
				{},
				Models.ContestPortalSpecialRegisterHost,
				objects,
				"portal_host_id",
				options,
				{master: this}
			);
		},

		getCmsHelper: function (files, template_selector, vars) {
			var output = null;
			_.each(
				_.isArray(files) ? files : [files],
				_.bind(function (file) {
					if (_.isNull(output)) {
						var cms = this.getWhere("contest_cms", {file: file});
						if (cms) {
							output = cms.getHbOutput(template_selector, vars) || null;
						}
					}
				}, this)
			);
			return output;
		},
	});

	Models.ContestPortalSpecialRegisterHost = Models.ContestPortalHost.extend({});

	Models.Contest = Models.Contest.extend({
		fetch: function () {
			if (!this.get("flavor")) {
				this.set(
					"flavor",
					this.get("master").getWhere("contest_flavors", {
						flavor_hash: this.get("flavor_hash"),
					})
				);
			}
		},
		getCmsTemplate: function (template_selector, vars) {
			var templates = [
				"type_" +
					this.get("master").get("user_type") +
					"_contest_" +
					this.get("contest_cms_hash"),
				"contest_" + this.get("contest_cms_hash"),
			];

			templates.push(
				"type_" +
					this.get("master").get("user_type") +
					"_flavor_" +
					this.get("flavor").get("flavor_cms_hash"),
				"flavor_" + this.get("flavor").get("flavor_cms_hash")
			);

			templates.push(
				"type_" + this.get("master").get("user_type") + "_flavor_default",
				"flavor_default"
			);

			return this.get("master").getCmsHelper(
				_.uniq(templates),
				template_selector,
				vars
			);
		},
		export: function () {
			var requested_user = this.get("master")
				.get("contest_portal_requested_users")
				.first();
			var output = {
				contest_cms_hash: this.get("contest_cms_hash"),
				contest_crumb_name: this.get("contest_crumb_name"),
				contest_hash: this.get("contest_hash"),
				contest_id: this.get("contest_id"),
				contest_internal_name: this.get("contest_internal_name"),
				contest_logo: this.get("contest_logo"),
				secondary_logo: this.get("secondary_logo"),
				alternate_logo: this.get("alternate_logo"),
				contest_name: this.get("contest_name"),
				contest_short_name: this.get("contest_short_name"),
				contest_portal_name:
					this.get("contest_portal_name") || this.get("contest_short_name"),
				requested_user: (requested_user || {}).attributes,
				terms:
					(
						_.findWhere(this.get("master").get("contest_terms"), {
							contest_id: this.get("contest_id"),
						}) || {}
					).terms || {},
				session: AoPS.session,
				supervisor_registration_has_ended: this.get("master").get(
					"supervisor_registration_has_ended"
				),
			};
			output["user_type_is_" + this.get("master").get("user_type")] = true;

			return output;
		},
		submitRegistration: function (formData, success, failure) {
			var loadingModal = AoPS.Contests.Utils.CreateModalInescapable();
			setTimeout(
				_.bind(function () {
					AoPS.Contests.Utils.ajax_special_register_runner.run(
						"submit-registration",
						{
							contest_id: this.get("contest_id"),
							user_type: this.get("master").get("user_type"),
							json_data: JSON.stringify(formData),
							redirect_url: window.location.href,
						},
						_.bind(function (ok, data) {
							AoPS.Ui.Modal.removeModal(loadingModal);
							if (ok) {
								this.get("master").addOrUpdateContestPortalRequestedUser(
									data.response.contest_portal_requested_users || []
								);

								if (data.response.autologin_url) {
									window.location.href = data.response.autologin_url;
									return;
								}

								if (_.isFunction(success)) {
									success();
								}
							} else {
								AoPS.Contests.Utils.CreateModalAlert(
									$("<div />")
										.css("max-width", "480px")
										.text("Error: " + (data.error_msg || data.error_code))
								);

								if (_.isFunction(failure)) {
									failure();
								}
							}
						}, this)
					);
				}, this),
				500
			);
		},
	});

	return Models;
})(AoPS.Contests.Models);
